import React, { useEffect, useMemo, useState } from 'react'
import {
  IconErase,
  IconLesson,
  IconWspAlert,
  ToolTipInfo,
  IconSignPlus,
  ConfirmModal,
  CheckboxOption,
  IconIllustratedAlert,
  ModalLayout,
  StickyButton,
  ListItem,
} from '@Knowledge-OTP/znk-ui-components'
import PlanListItem from './PlanListItem'
import CardHeader from '../Components/CardHeader'
import useStudentsCheckIn from './Model/useStudentsCheckIn'
import useStudentsMissingHomeworks from './Model/useStudentsMissingHomeworks'
import useStudentsPendingLessons from './Model/useStudentsPendingLessons'
import useStudentsMissingLessons from './Model/useStudentsMissingLessons'
import CheckInStudentModal from './Modal/CheckInStudent'
import DismissNotification from './Modal/DismissNotification'
import SkeletonListItem from './PlanListItem/Skeleton'
import { TabContent, TabPane } from 'reactstrap'
import useTranslation from '../../../../../i18n/useTranslation'
import moment from 'moment'
import { CheckInTypeInt } from '../../../../Plans/modal/scheduled/CheckIns'
import useSendWspAlertForCheckInBulk from './Model/useSendWspAlertForCheckInBulk'
import useIssueCheckInToStudentBulk from './Model/useIssueCheckInToStudentBulk'
import { showAlert } from '../../../../../common/Alert/util'
import { useDispatch } from 'react-redux'
import './index.css'
// import { planQueryResult } from '../TestDates/Model/QueryResults/planQueryResult'

const IssueCheckIn = (props) => {
  const typeEnum = {
    planCheckIn: 'checkinPlans',
    missingHomeworks: 'homework',
    pendingLessons: 'pendingLessons',
    missingLessons: 'missingLessons',
    general: 'general'
  }
  const { type = typeEnum.planCheckIn } = props
  console.log(type)
  const { data: dataCheckIn, loading: checkinPlansLoading, refetch: refetchCheckIn } = useStudentsCheckIn({})
  const { data: dataHomework, loading: homeworkLoading, refetch: refetchHomework } = useStudentsMissingHomeworks({})
  const { data: dataPending, loading: pendingLessonsLoading, refetch: refetchPending } = useStudentsPendingLessons({})
  const { data: dataMissing, loading: missingLessonsLoading, refetch: refetchMissing } = useStudentsMissingLessons({})
  const [fakeLoading, setFakeLoading] = useState(false)
  const [selectedStudents, setSelectedStudents] = useState([])
  const [showBulkSendConfirmModal, setShowBulkSendConfirmModal] = useState(false)
  const [bulkSendEvents, setBulkSendEvents] = useState([])
  const [showBulkDismissConfirmModal, setShowBulkDismissConfirmModal] = useState(false)
  const [bulkDismissEvents, setBulkDismissEvents] = useState([])
  const [sendStudents, setSendStudents] = useState(true)
  const [sendParents, setSendParents] = useState(true)
  const dispatch = useDispatch()
  const [sendWspAlertBulk, { loading: loadingBulkSend }] = useSendWspAlertForCheckInBulk(
    (res) => {
      const response = res?.sendWspAlertForCheckInBulk || {}
      const sent = response?.sent || 0
      const failed = response?.failed || 0
      const failedEvents = (response?.results || []).filter(({ status }) => status !== 'success')
      const failedKeys = failedEvents.map(({ eventKey }) => eventKey).filter(Boolean).join(', ')
      const status = failed === 0 ? 'success' : 'error'
      const failedMessage = failedKeys ? ` Failed events: ${failedKeys}` : ''
      showAlert({
        text: `Sent: ${sent}, Failed: ${failed}.${failedMessage}`,
        status
      }, dispatch)
      setShowBulkSendConfirmModal(false)
      setBulkSendEvents([])
      setSendStudents(true)
      setSendParents(true)
      clearSelection()
      refetch()
    },
    (error) => {
      showAlert({
        text: error?.toString() || 'Error!',
        status: 'error'
      }, dispatch)
    }
  )
  const [issueCheckInBulk, { loading: loadingBulkIssue }] = useIssueCheckInToStudentBulk(
    (res) => {
      const response = res?.issueCheckInToStudentBulk || {}
      const sent = response?.sent || 0
      const failed = response?.failed || 0
      const failedEvents = (response?.results || []).filter(({ status }) => status !== 'success')
      const failedKeys = failedEvents.map(({ eventKey }) => eventKey).filter(Boolean).join(', ')
      const status = failed === 0 ? 'success' : 'error'
      const failedMessage = failedKeys ? ` Failed events: ${failedKeys}` : ''
      showAlert({
        text: `Dismissed: ${sent}, Failed: ${failed}.${failedMessage}`,
        status
      }, dispatch)
      setShowBulkDismissConfirmModal(false)
      setBulkDismissEvents([])
      clearSelection()
      refetch()
    },
    (error) => {
      showAlert({
        text: error?.toString() || 'Error!',
        status: 'error'
      }, dispatch)
    }
  )
  const [descriptionMulti, setDescriptionMulti] = useState('')

  useEffect(() => {
    switch(type) {
      case 'checkinPlans':
        setDescriptionMulti(translate('dashboard.issueCheckIn.checkinPlan'))
        break
      case 'homework':
        setDescriptionMulti(translate('dashboard.issueCheckIn.homework'))
        break
      case 'pendingLessons':
        setDescriptionMulti(translate('dashboard.issueCheckIn.pending'))
        break
      case 'missingLessons':
        setDescriptionMulti(translate('dashboard.issueCheckIn.missing'))
        break
      default:
        setDescriptionMulti('')
    }
    // eslint-disable-next-line
  }, [type])

  const allNotifications = useMemo(() => {
    const notifications = {}

    if (dataCheckIn?.plansCheckIns) {
      notifications.checkinPlans = dataCheckIn.plansCheckIns.checkinPlans || []
    }
    if (dataHomework?.studentsHomeworks) {
      notifications.homework = dataHomework.studentsHomeworks.homework || []
    }

    if (dataPending?.studentsPendingLessons) {
      notifications.pendingLessons = dataPending.studentsPendingLessons.pendingLessons || []
    }

    if (dataMissing?.studentsMissingLessons) {
      notifications.missingLessons = dataMissing.studentsMissingLessons.missingLessons || []
    }

    return notifications
  }, [dataCheckIn, dataHomework, dataPending, dataMissing])

  const { homework, missingLessons, pendingLessons, checkinPlans, general } = allNotifications
  const lengthNotifications = Array.isArray(allNotifications[type])
    ? allNotifications[type].length
    : 0
  const isMultiSelectMode = selectedStudents.length > 0

  const { translate } = useTranslation()
  const titleEnum = {
    checkinPlans: translate('dashboard.issueCheckIn.checkInPlansTitle'),
    homework: translate('dashboard.issueCheckIn.homeworkTitle'),
    pendingLessons: translate('dashboard.issueCheckIn.pendingLessonsTitle'),
    missingLessons: translate('dashboard.issueCheckIn.missingLessonsTitle')
  }
  const infoEnum = {
    checkinPlans: translate('dashboard.issueCheckIn.checkInPlansInfo'),
    homework: translate('dashboard.issueCheckIn.homeworkInfo'),
    pendingLessons: translate('dashboard.issueCheckIn.pendingLessonsInfo'),
    missingLessons: translate('dashboard.issueCheckIn.missingLessonsInfo')
  }
  const getStudentId = (student = {}) => student?.id || student?._id
  const getTaskIds = (student = {}) => {
    return (student?.tasksForWidget || [])
      .map((task) => task?.id)
      .filter(Boolean)
      .sort()
  }
  const getTasksEventKey = (tasksForWidget = []) => {
    const tasksKey = (tasksForWidget || [])
      .map((task, index) => {
        const taskId = task?.id || task?._id || 'task'
        const taskDate = task?.endDate || `index-${index}`
        return `${taskId}-${taskDate}`
      })
      .sort()

    if (tasksKey.length === 0) return null
    return tasksKey.join('|')
  }
  const getEventId = (student = {}) => {
    if (type === typeEnum.planCheckIn) {
      return student?.checkInDate?.id || student?.checkInDate?._id || student?.checkInDate?.date
    }
    return getTasksEventKey(student?.tasksForWidget || [])
  }
  const getSelectionKey = (student = {}) => {
    const eventId = getEventId(student)
    if (eventId) return `${type}-${eventId}`
    return `${type}-${getStudentId(student)}`
  }
  const clearSelection = () => {
    setSelectedStudents([])
  }
  const isSelected = (student = {}) => {
    return selectedStudents.some(({ key }) => key === getSelectionKey(student))
  }
  const toggleStudentSelection = (selectionData = {}) => {
    setSelectedStudents((prevState) => {
      const alreadySelected = prevState.some(({ key }) => key === selectionData?.key)
      if (alreadySelected) return prevState.filter(({ key }) => key !== selectionData?.key)
      return prevState.concat(selectionData)
    })
  }

  const openSendWspAlertForSelected = () => {
    if (selectedStudents.length === 0) {
      showAlert({ text: 'Select at least one event to continue', status: 'error' }, dispatch)
      return
    }
    const events = parseEventsToBulk(selectedStudents)

    if (events.length === 0) {
      showAlert({ text: 'Select at least one valid event to continue', status: 'error' }, dispatch)
      return
    }

    setBulkSendEvents(events)
    setShowBulkSendConfirmModal(true)
  }

  const closeBulkSendConfirmModal = () => {
    if (loadingBulkSend) return
    setShowBulkSendConfirmModal(false)
    setBulkSendEvents([])
    setSendStudents(true)
    setSendParents(true)
  }

  const confirmBulkSend = () => {
    if (!sendStudents && !sendParents) {
      showAlert({ text: 'Select at least one option to continue', status: 'error' }, dispatch)
      return
    }
    if ((bulkSendEvents || []).length === 0) {
      showAlert({ text: 'Select at least one valid event to continue', status: 'error' }, dispatch)
      return
    }
    sendWspAlertBulk({
      variables: {
        events: bulkSendEvents,
        includeStudents: sendStudents,
        includeParents: sendParents
      }
    })
  }

  const parseEventsToBulk = (events = []) => {
    const seenKeys = new Set()
    const parseEvents = events
      .map((selectedEvent) => {
        const eventIdentity = [
          selectedEvent?.studentId || '',
          selectedEvent?.reason || '',
          selectedEvent?.checkInId || '',
          selectedEvent?.serviceReason || '',
          (selectedEvent?.taskIds || []).join(',')
        ].join('|')
        return {
          eventIdentity,
          eventKey: selectedEvent?.key,
          studentId: selectedEvent?.studentId,
          reason: selectedEvent?.reason,
          checkInId: selectedEvent?.checkInId || null,
          serviceReason: selectedEvent?.serviceReason || null,
          taskIds: selectedEvent?.taskIds || []
        }
      })
      .filter((eventData) => {
        if (!eventData?.studentId || !eventData?.reason) return false
        if (seenKeys.has(eventData.eventIdentity)) return false
        seenKeys.add(eventData.eventIdentity)
        return true
      })
      .map(({ eventIdentity, ...eventData }) => eventData)

    return parseEvents
  }

  const openDismissNotificationForSelected = () => {
    if (selectedStudents.length < 1) {
      showAlert({ text: 'Select at least one event to continue', status: 'error' }, dispatch)
      return
    }
    const events = parseEventsToBulk(selectedStudents)
    if (events.length === 0) {
      showAlert({ text: 'Select at least one valid event to continue', status: 'error' }, dispatch)
      return
    }
    setBulkDismissEvents(events)
    setShowBulkDismissConfirmModal(true)
  }

  const closeBulkDismissConfirmModal = () => {
    if (loadingBulkIssue) return
    setShowBulkDismissConfirmModal(false)
    setBulkDismissEvents([])
  }

  const confirmBulkDismiss = () => {
    if ((bulkDismissEvents || []).length === 0) {
      showAlert({ text: 'Select at least one valid event to continue', status: 'error' }, dispatch)
      return
    }
    issueCheckInBulk({ variables: { events: bulkDismissEvents } })
  }

  const hideSendWspAlertAction = selectedStudents[0]?.reason === 'pending' ||
    (selectedStudents.length === 0 && type === typeEnum.pendingLessons)
  const headerActions = []
  if (!hideSendWspAlertAction) {
    headerActions.push({
      key: 'sendWspAlert',
      text: translate('dashboard.issueCheckIn.listItem.sendWspAlert'),
      className: 'text-info hover-icon border-0',
      icon: <IconWspAlert size={15} className={`mr-1`} />,
      onClick: openSendWspAlertForSelected
    })
  }
  headerActions.push({
    key: 'dismissNotification',
    text: translate('dashboard.issueCheckIn.listItem.dismissNotification'),
    className: 'text-error hover-icon border-0',
    icon: <IconErase size={15} className={`mr-1`} />,
    onClick: openDismissNotificationForSelected
  })

  const controlsContent = isMultiSelectMode ? (
    <div className='issue-checkin-controls'>
      <span className='text-gray h50 issue-checkin-controls-count'>{`${selectedStudents.length} selected`}</span>
      {headerActions.map((action) => (
        <button
          key={action.key}
          type='button'
          className={`issue-checkin-controls-action d-flex flex-row align-items-center h45 p-0 border-0 bg-transparent ${action.className}`}
          onClick={action.onClick}
          disabled={loadingBulkSend || loadingBulkIssue}
        >
          {action.icon}
        </button>
      ))}
      <span className='text-info hover-icon h45 cursor-pointer issue-checkin-controls-cancel' onClick={clearSelection}> <IconSignPlus className='text-gray' size={15} /></span>
    </div>
  ) : null

  const refetch = () => {
    clearSelection()
    setFakeLoading(true)
    if (type === typeEnum.planCheckIn) {
      refetchCheckIn().then(
        () => { setFakeLoading(false) },
        () => { setFakeLoading(false) }
      )
    }
    if (type === typeEnum.missingHomeworks) {
      refetchHomework().then(
        () => { setFakeLoading(false) },
        () => { setFakeLoading(false) }
      )
    }
    if (type === typeEnum.pendingLessons) {
      refetchPending().then(
        () => { setFakeLoading(false) },
        () => { setFakeLoading(false) }
      )
    }
    if (type === typeEnum.missingLessons) {
      refetchMissing().then(
        () => { setFakeLoading(false) },
        () => { setFakeLoading(false) }
      )
    }
  }
  const loading = useMemo(() => checkinPlansLoading || fakeLoading || pendingLessonsLoading || homeworkLoading || missingLessonsLoading,
    [checkinPlansLoading, homeworkLoading, fakeLoading, pendingLessonsLoading, missingLessonsLoading])

  const getTooltipText = (tasksForWidget = []) => {
    return tasksForWidget?.map(
      (task, index) => {
        const taskKey = task ? (task.id || task._id || task.title || 'task') : 'task'
        const taskDate = task ? task.endDate : index
        return (
          <span key={taskKey + '-' + taskDate}>{task?.title} <br />
            <small>{moment(task?.endDate).format('YYYY-MM-DD HH:mm')} <br /></small>
            <small>{task?.educator?.firstName} {task?.educator?.lastName} <br /></small>
            <small>********** <br /></small>
          </span>
        )
      }
    )
  }

  return (
    <div className='column w-100'>
      <CardHeader
        innerInfo={infoEnum[type]}
        titleModalInfo={translate('dashboard.issueCheckIn.infoTitleModal')}
        title={titleEnum[type]}
        className='secondaryBackground'
        onReload={() => { refetch() }}
        loading={loading}
        type={type}
        useControls={!isMultiSelectMode}
        controlsContent={controlsContent}
      />
      <div className='d-flex flex-column w-100 m-0 p-0'>
        <TabContent activeTab={loading ? 'loading' : lengthNotifications > 0 ? type : 'blank'}>
          <TabPane tabId='loading'>
            <div className='d-flex flex-column px-5'>
              {
                new Array(10).fill(0).map((_, index) => {
                  return (
                    <SkeletonListItem key={`skeleton-${index}`} className='mb-2' />
                  )
                })
              }
            </div>
          </TabPane>
          <TabPane tabId={typeEnum.planCheckIn}>
            <>
              {
                (checkinPlans || []).map(
                  (student, index) => {
                    const studentId = getStudentId(student)
                    const selectionKey = getSelectionKey(student)
                    const reason = student?.checkInDate?.type?.toString() !== 'regular' ? student?.checkInDate?.type : 'checkinPlan'
                    const description = translate('dashboard.issueCheckIn.checkinPlan')
                    const text = `Check In Plan - ${translate(CheckInTypeInt[student?.checkInDate?.type])}`
                    const selectionData = {
                      key: selectionKey,
                      studentId,
                      studentData: student,
                      reason,
                      description,
                      text,
                      serviceReason: null,
                      checkInId: student?.checkInDate?.id || null,
                      taskIds: []
                    }
                    const textToShowOnTooltip = (
                      <>
                        <span>{student.planName}</span> <br />
                        <small>{`${student.firstName} ${student.lastName}`}</small> <br />
                        <small>{moment(student.checkInDate?.date).format('YYYY-MM-DD HH:mm')} <br /></small>
                      </>
                    )
                    return (
                      <ToolTipInfo
                        key={`checkin-plan-${selectionKey || studentId || index}`}
                        tooltipId={`checkin-plan-${index}`}
                        disable={false}
                        innerElement={
                          <div>
                            {textToShowOnTooltip}
                          </div>
                        }
                        place='bottom'
                      >
                        <PlanListItem
                          refetch={refetch}
                          studentName={`${student?.firstName} ${student?.lastName}`}
                          studentId={studentId}
                          text={text}
                          reason={reason}
                          description={description}
                          studentData={student}
                          onAvatarClick={() => { toggleStudentSelection(selectionData) }}
                          isSelected={isSelected(student)}
                          isMultiSelectMode={isMultiSelectMode}
                        />
                      </ToolTipInfo>
                    )
                  }
                )
              }
            </>
          </TabPane>
          <TabPane tabId={typeEnum.missingHomeworks}>
            <>
              {
                (homework || []).map(
                  (student, index) => {
                    const studentId = getStudentId(student)
                    const selectionKey = getSelectionKey(student)
                    const textToShowOnTooltip = getTooltipText(student?.tasksForWidget)
                    const textMissingHomework = student?.tasksForWidget[0]?.service?.name + ' ' + student?.tasksForWidget[0]?.topic?.name
                    const reason = 'homework'
                    const description = translate('dashboard.issueCheckIn.homework')
                    const selectionData = {
                      key: selectionKey,
                      studentId,
                      studentData: student,
                      reason,
                      description,
                      text: textMissingHomework,
                      serviceReason: student?.tasksForWidget[0]?.topic?.id,
                      checkInId: null,
                      taskIds: getTaskIds(student)
                    }
                    return (
                      <ToolTipInfo
                        key={`homework-${selectionKey || studentId || index}`}
                        tooltipId={`homework-${index}`}
                        disable={false}
                        innerElement={
                          <div>
                            {textToShowOnTooltip}
                          </div>
                        }
                        place='bottom'
                      >
                        <PlanListItem
                          refetch={refetch}
                          studentName={`${student?.firstName} ${student?.lastName}`}
                          studentId={studentId}
                          text={textMissingHomework}
                          reason={reason}
                          description={description}
                          studentData={student}
                          serviceReason={student?.tasksForWidget[0]?.topic?.id}
                          onAvatarClick={() => { toggleStudentSelection(selectionData) }}
                          isSelected={isSelected(student)}
                          isMultiSelectMode={isMultiSelectMode}
                        />
                      </ToolTipInfo>
                    )
                  }
                )
              }

            </>
          </TabPane>
          <TabPane tabId={typeEnum.missingLessons}>
            <>
              {
                (missingLessons || []).map(
                  (student, index) => {
                    const studentId = getStudentId(student)
                    const selectionKey = getSelectionKey(student)
                    const textToShowOnTooltip = getTooltipText(student?.tasksForWidget)
                    const textMissingLessons = student?.tasksForWidget[0]?.service?.name + ' ' + student?.tasksForWidget[0]?.topic?.name
                    const reason = 'missing'
                    const description = translate('dashboard.issueCheckIn.missing')
                    const selectionData = {
                      key: selectionKey,
                      studentId,
                      studentData: student,
                      reason,
                      description,
                      text: textMissingLessons,
                      serviceReason: student?.tasksForWidget[0]?.topic?.id,
                      checkInId: null,
                      taskIds: getTaskIds(student)
                    }
                    return (
                      <ToolTipInfo
                        key={`missing-${selectionKey || studentId || index}`}
                        tooltipId={`missing-${index}`}
                        disable={false}
                        innerElement={
                          <div>
                            {textToShowOnTooltip}
                          </div>
                        }
                        place='bottom'
                      >
                        <PlanListItem
                          refetch={refetch}
                          studentName={`${student?.firstName} ${student?.lastName}`}
                          studentId={studentId}
                          text={textMissingLessons}
                          reason={reason}
                          description={description}
                          studentData={student}
                          serviceReason={student?.tasksForWidget[0]?.topic?.id}
                          onAvatarClick={() => { toggleStudentSelection(selectionData) }}
                          isSelected={isSelected(student)}
                          isMultiSelectMode={isMultiSelectMode}
                        />
                      </ToolTipInfo>
                    )
                  }
                )
              }

            </>
          </TabPane>
          <TabPane tabId={typeEnum.pendingLessons}>
            <>

              {
                (pendingLessons || []).map(
                  (student, index) => {
                    const studentId = getStudentId(student)
                    const selectionKey = getSelectionKey(student)
                    const textToShowOnTooltip = getTooltipText(student?.tasksForWidget)
                    const reason = 'pending'
                    const description = translate('dashboard.issueCheckIn.pending')
                    const selectionData = {
                      key: selectionKey,
                      studentId,
                      studentData: student,
                      reason,
                      description,
                      text: 'Pending Lessons',
                      serviceReason: null,
                      checkInId: null,
                      taskIds: getTaskIds(student)
                    }
                    return (
                      <ToolTipInfo
                        key={`pending-${selectionKey || studentId || index}`}
                        tooltipId={`pending-${index}`}
                        disable={false}
                        innerElement={
                          <div>
                            {textToShowOnTooltip}
                          </div>
                        }
                        place='bottom'
                      >
                        <PlanListItem
                          refetch={refetch}
                          studentName={`${student?.firstName} ${student?.lastName}`}
                          studentId={studentId}
                          text='Pending Lessons'
                          reason={reason}
                          description={description}
                          studentData={student}
                          onAvatarClick={() => { toggleStudentSelection(selectionData) }}
                          isSelected={isSelected(student)}
                          isMultiSelectMode={isMultiSelectMode}
                        />
                      </ToolTipInfo>
                    )
                  }
                )
              }
            </>
          </TabPane>
          <TabPane tabId={typeEnum.general}>
            <>

              {
                (general || []).map(
                  (student, index) => {
                    const studentId = getStudentId(student)
                    const selectionKey = getSelectionKey(student)
                    const textToShowOnTooltip = getTooltipText(student?.tasksForWidget)
                    const reason = 'general'
                    const description = translate('dashboard.issueCheckIn.general')
                    const selectionData = {
                      key: selectionKey,
                      studentId,
                      studentData: student,
                      reason,
                      description,
                      text: 'General',
                      serviceReason: null,
                      checkInId: null,
                      taskIds: getTaskIds(student)
                    }
                    return (
                      <ToolTipInfo
                        key={`general-${selectionKey || studentId || index}`}
                        tooltipId={`general-${index}`}
                        disable={false}
                        innerElement={
                          <div>
                            {textToShowOnTooltip}
                          </div>
                        }
                        place='bottom'
                      >
                        <PlanListItem
                          refetch={refetch}
                          studentName={`${student?.firstName} ${student?.lastName}`}
                          studentId={studentId}
                          text='General'
                          reason={reason}
                          description={description}
                          studentData={student}
                          onAvatarClick={() => { toggleStudentSelection(selectionData) }}
                          isSelected={isSelected(student)}
                          isMultiSelectMode={isMultiSelectMode}
                        />
                      </ToolTipInfo>
                    )
                  }
                )
              }
            </>
          </TabPane>
          <TabPane tabId='blank'>
            <div className='d-flex flex-row justify-content-center w-100' style={{ height: '200px' }}>
              <div className='d-flex flex-column justify-content-center align-items-center text-center'>
                <IconLesson size={40} className='text-disabled' />
                <label className='h45 mt-4 text-gray'>There are no notifications</label>
              </div>
            </div>
          </TabPane>
        </TabContent>
      </div>
      <CheckInStudentModal />
      <DismissNotification />
      <ModalLayout
        className='modal-colored modal-centered fixed-head-modal'
        isOpen={showBulkSendConfirmModal}
        toggle={closeBulkSendConfirmModal}
        backdrop='static'
        topHead={
          <div className='d-flex flex-column'>
              <IconIllustratedAlert className='mb-3' size={80} />
              <span className='h2 font-weight-bold'>{translate("dashboard.issueCheckIn.listItem.sendWspModal.title") || "Check-In Student"}</span>
          </div>
      
        }
        disabledScrollAnimation
      >
      <div className='m-0 p-0'>
      <span className='text-gray'>{descriptionMulti}</span>

        <div className='d-flex flex-column py-6'>
          <div className='d-flex flex-column align-items-left mb-2'>
            <>
            <ListItem 
              className='py-2 mb-1'
              Left={
                <span className='ml-2'>Send all students</span>

              }
              Right={
                <CheckboxOption
                  defaultState={sendStudents}
                  value={sendStudents}
                  onChange={(newValue) => { setSendStudents(newValue) }}
                />
              }

            />
               <ListItem 
              className='py-2 mb-1'
              Left={
               <span className='ml-2'>Send all parents</span>
              }
              Right={
                <CheckboxOption
                defaultState={sendParents}
                value={sendParents}
                onChange={(newValue) => { setSendParents(newValue) }}
              />
              }
            />
            </>
            {/* <span className='ml-2'>Send all students</span> */}
          </div>
          {/* <div className='d-flex flex-row align-items-center'>
            <CheckboxOption
              defaultState={sendParents}
              value={sendParents}
              onChange={(newValue) => { setSendParents(newValue) }}
            />
            <span className='ml-2'>Send all parents</span>
          </div> */}
        </div>

          <StickyButton
            disabled={loadingBulkSend}
            onClickButtonFunction={() => {
              confirmBulkSend()
            }}
            activity={loadingBulkSend}
            color='#696CFF'
            className='w-100 mb-3'
            size='medium'
            label={translate("dashboard.issueCheckIn.listItem.sendWspModal.buttonLabel")}
          />
        </div>
        

      </ModalLayout>

      <ConfirmModal
        classNameConfirm='text-error'
        isOpen={showBulkDismissConfirmModal}
        backdrop={'static'}
        toggle={closeBulkDismissConfirmModal}
        title={translate('dashboard.issueCheckIn.listItem.dismissModal.sure') || 'Are you sure?'}
        body={translate('dashboard.issueCheckIn.listItem.dismissModal.body') || 'This action cannot be undoned'}
        confirmAction={confirmBulkDismiss}
        cancelAction={closeBulkDismissConfirmModal}
        confirmText={translate('dashboard.issueCheckIn.listItem.dismissModal.confirm') || 'Confirm'}
        cancelText={translate('dashboard.issueCheckIn.listItem.dismissModal.cancel') || 'Cancel'}
        disabledCancel={loadingBulkIssue}
        loading={loadingBulkIssue}
      />
    </div>
  )
}

export default IssueCheckIn
